<template>
  <v-card :class="$options.name">
    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field
          v-model="form.name"
          :value="data.name"
          :rules="rules.name"
          label="Название роли"
        />

        <permissions-select
          v-if="isEdit"
          :data="data.permissions"
          :items-list="permissionsList"
          @change="setPermissions"
        />

        <regions-select
          v-if="isEdit"
          v-model="form.regions"
          :data="data.regions"
          :items-list="regionsList"
        />

        <div class="role-form__access-container">
          <v-btn
            color="blue"
            class="role-form__access-button elevation-0 mt-2 mb-4"
            title="Настройка доступов к наборам слоёв"
            size="x-large"
            dark
            @click="toggleAcessCollection"
          >
            <v-icon>edit</v-icon>
            <span class="ml-2 mb-0">
              Настройка доступов к наборам слоёв
            </span>
          </v-btn>

          <user-layers-access-table
            v-if="showAcessCollection"
            :layers="collectionsList"
            :data="form.layerCollectionPermissions || []"
            :is-dialog-open="showAcessCollection"
            @closed="toggleAcessCollection"
            @change="setCollectionActionPermissions"
          />

          <v-btn
            color="blue"
            class="role-form__access-button elevation-0 mt-2 mb-4"
            title="Настройка доступов к слоям"
            size="x-large"
            dark
            @click="toggleAcessLayers"
          >
            <v-icon>edit</v-icon>
            <span class="ml-2 mb-0">
              Настройка доступов к слоям
            </span>
          </v-btn>

          <user-layers-access-table
            v-if="showAcessLayers"
            :layers="layersList"
            :data="form.layerPermissions || []"
            :is-dialog-open="showAcessLayers"
            @closed="toggleAcessLayers"
            @change="setLayerActionPermissions"
          />
        </div>
      </v-form>
    </v-card-text>

    <v-card-actions class="ml-2 mr-2">
      <slot name="action-buttons" />
      <div class="flex-grow-1" />
      <v-btn
        v-permission="['role-create', 'role-edit']"
        color="primary lighten-1"
        text
        @click="onSubmit"
        v-text="buttonLabel"
      />
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState } from 'vuex';
import RegionsSelect from '@/components/page/regions/regions-select';
import UserLayersAccessTable from '@/components/dialogs/UserLayersAccessTable.vue';
import PermissionsSelect from './RoleForm/PermissionsSelect.vue';

const createDefaultForm = () => ({
  name: null,
  parent: null,
  regions: [],
  permissions: [],
  layerPermissions: [],
  layerCollectionPermissions: [],
});

export default {
  name: 'role-form',

  components: {
    UserLayersAccessTable,
    PermissionsSelect,
    RegionsSelect,
  },

  model: {
    prop: 'value',
    event: 'change',
  },

  props: {
    isEdit: Boolean,
    data: {
      type: Object,
      default: createDefaultForm,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    permissionsList: {
      type: Array,
      default: () => ([]),
    },
    regionsList: {
      type: Array,
      default: () => ([]),
    },
    rolesList: {
      type: Array,
      default: () => ([]),
    },
  },

  data: () => ({
    form: createDefaultForm(),
    valid: true,
    showAcessLayers: false,
    showAcessCollection: false,
    rules: {
      name: [
        v => !!v || 'Название роли обязательно для заполнения',
      ],
    },
  }),

  computed: {
    ...mapState('layer-objects', { layersList: 'fullList' }),
    ...mapState('layerCollections', { collectionsList: 'fullList' }),

    formTitle() {
      return this.isEdit ? 'Редактирование роли' : 'Новая роль';
    },

    buttonLabel() {
      return this.isEdit ? 'Сохранить изменения' : 'Создать роль';
    },
  },

  watch: {
    data: {
      deep: true,
      immediate: true,
      handler: 'updateData',
    },
    form: {
      deep: true,
      handler(value) {
        this.$emit('change', value);
      },
    },
  },

  methods: {
    setPermissions(permissions) {
      this.form.permissions = [...permissions];
    },

    onSubmit() {
      if (this.$refs.form.validate()) {
        if (this.form.permissions.length && typeof this.form.permissions[0] === 'object') {
          this.form.permissions = this.form.permissions.map(({ id }) => id);
        }

        if (this.form.regions.length && typeof this.form.regions[0] === 'object') {
          this.form.regions = this.form.regions.map(({ id }) => id);
        }

        this.$emit('change', this.form);
        this.$emit('submit', this.form);
      }
    },

    updateData() {
      this.form = {
        ...this.form,
        ...this.data,
      };
    },

    toggleAcessLayers() {
      this.showAcessLayers = !this.showAcessLayers;
    },

    toggleAcessCollection() {
      this.showAcessCollection = !this.showAcessCollection;
    },

    setLayerActionPermissions(data) {
      this.toggleAcessLayers();
      this.form.layerPermissions = { ...data };
    },

    setCollectionActionPermissions(data) {
      this.toggleAcessCollection();
      this.form.layerCollectionPermissions = { ...data };
    },
  },
};
</script>

<style lang="scss" scoped>
.role-form {
  //
  &__access-button {
    width: 50%;
  }

  &__access-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
}
</style>
